var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDoubleArrowNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#E3E5E9",
    fill: "#FFF",
    d: "M4.425 3.5h26v25.999h-26V3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#B3B4B6",
    d: "M12.186 10.503c-.274 0 .474.099-.329.3-.426.401-.008 1.053.406 1.453l4.382 4.246-4.507 4.245c-.424.402-.866 1.052-.454 1.453 1.306.402.665.402 1.089 0l5.707-4.971c-.225.131-.111-.454-.104-.727.003-.272-.108-.533.314-.726l-5.748-4.973a1.075 1.075 0 0 0-.756-.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#B3B4B6",
    d: "M17.317 10.503c.143 0-.118.099-.329.3-.43.401-.005 1.053.405 1.453l4.381 4.246-4.503 4.245c-.427.402-.869 1.052-.454 1.453.416.402.661.402 1.086 0l5.276-4.971c.207.131.322-.454.328-.727a.993.993 0 0 0-.304-.726l-4.473-4.973c-.862-.201-1.138-.3-1.413-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoubleArrowNext);
export default __webpack_public_path__ + "static/media/ico-double-arrow-next.de6db3a44d781b5c0f3812ab4361501c.svg";
export { ForwardRef as ReactComponent };